import * as JSCookie from 'js-cookie';
import { RouteTo } from 'lib/utils/routing';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router';
import { toast } from 'react-toastify';
import UserDucks from 'stores/ducks/User.duck';

/**
 * Used to protect route
 */
export default function restrictRoute(Component) {
	class AuthenticatedComponent extends React.Component<{
		isLoggedIn: boolean;
		router: any;
	}> {
		constructor(props) {
			super(props);
		}

		public checkAuth = () => {
			if (JSCookie.get('token') !== undefined || this.props.isLoggedIn) {
				return <Component {...this.props} />;
			}

			toast.error('You need to log-in to access this section. ');
			return <Redirect to={RouteTo.login()} />;
		};

		public render() {
			return this.checkAuth();
		}
	}

	const mapstateToProps = state => {
		return {
			isLoggedIn: UserDucks.isAuthenticated(state),
		};
	};

	return connect(mapstateToProps)(withRouter(AuthenticatedComponent));
}



// WEBPACK FOOTER //
// ./src/components/guards/router/RestrictRoute.tsx